import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { studentCreationApi } from "../server/institutionAllApi";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddTutor = () => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const [formState, setFormState] = useState({
    name: "",
    email: "",
    phone: "",
    // roll_no: "",
    address: "",
    gender: "",
    // admission_Date: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [token, setToken] = useState("");
  const [courseCategories, setCourseCategories] = useState("");
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const navigate = useNavigate();
  const [isNameTouched, setIsNameTouched] = useState(false);
  const [isMobileTouched, setIsMobileTouched] = useState(false);
  const [isEmailTouched, setIsEmailTouched] = useState(false);
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Toggle function for password field
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Toggle function for confirm password field
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const file = input.target.files[0];
      
      // Allowed image types
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
      
      if (!allowedTypes.includes(file.type)) {
        setSnackbarMessage("Invalid file format! Please upload an image (PNG, JPG, JPEG, GIF).");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        return; // Stop further execution
      }
  
      // If valid image, read and preview it
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  
  useEffect(() => {
    // const token1 = localStorage.getItem("token");
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }
    fetchdepartment();
  }, []);

  const fetchdepartment = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(loading) return; // Prevent multiple submissions
    // setError("");
    if (formState.name && formState.name.length < 2) {
      setError(true);
      return;
    }

    if(formState.phone.length < 8 ||
      formState.phone.length > 15){
        setError(true);
        return;
      }


    setLoading(true); // Start loading state

    try {
      // const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const validateEmail = (email) => {
        // Basic regex for emails ending in .com, .in, .org, etc.
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
      };
      if (!validateEmail(formState.email)) {
        setSnackbarMessage("Enter valid email");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        setLoading(false);
        return;
      } else {
        
      

      // Create a FormData object
      const formData = new FormData();

      // Append each field from formState to the FormData object
      formData.append("name", formState.name);
      formData.append("email", formState.email);
      formData.append("phone", formState.phone);
      formData.append("address", formState.address);
      formData.append("gender", formState.gender);

      // Append any other form values like selectedDepartment if required
      formData.append("selectedDepartment", selectedDepartment);

      // Append the selected image file (if any)
      const imageInput = document.querySelector("#student-image");
      if (imageInput && imageInput.files[0]) {
        formData.append("image", imageInput.files[0]);
      }

      // Send the formData with axios post request
      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-tutor`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Ensure it's set to multipart/form-data
          },
        }
      );

      if (response.status && response.status === 201) {
        // If response is successful, navigate to the tutor list

        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setLoading(false);
        setTimeout(() => {
          navigate("/tutor-list");
        }, 2000);
      }
    }
    } catch (err) {
      if (err.response && err.response.status === 409) {
        setSnackbarMessage(err.response.data.message || "Tutor already exists.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        setLoading(false);
      }else{
      console.error("Error creating tutor:", err);
      setSnackbarMessage("Failed to create. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      setLoading(false);
      }
    } 
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <h6 className="text-md text-primary-light mb-16">
                  Profile Image
                </h6>
                {/* Upload Image Start */}
                <div className="mb-24 mt-16">
                  <div className="avatar-upload">
                    <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                      {/* File input hidden using CSS */}
                      <input
                        type="file"
                        id="student-image"
                        accept="image/*"
                        className="d-none" // This hides the file input
                        onChange={readURL}
                      />
                      <label
                        htmlFor="student-image" // Bind label to file input
                        className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                      >
                        <Icon icon="solar:camera-outline" className="icon" />
                      </label>
                    </div>
                    <div className="avatar-preview">
                      <div
                        id="imagePreview"
                        style={{
                          backgroundImage: `url(${imagePreview})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* Upload Image End */}
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="name"
                          name="name"
                          value={formState.name}
                          onChange={(e) => {
                            const regex = /^[A-Za-z\s]*$/; // Allow alphabets and spaces only
                            const value = e.target.value;

                            if (value === "" || value.trim() !== "") {
                              if (regex.test(value)){
                              handleInputChange(e); // Update state only if valid
                            }}
                          }}
                          onBlur={() => setIsNameTouched(true)} // Mark field as touched when focus is lost
                          placeholder="Enter full name"
                          required
                        />
                        {isNameTouched && (
                          <>
                            {formState.name && formState.name.length < 2 && (
                              <small className="text-danger-600">
                                Name must be at least 2 characters long
                              </small>
                            )}
                          </>
                        )}
                        {/* {isNameTouched && !formState.name && (
                          <small className="text-danger-600">
                            Name is required
                          </small>
                        )} */}
                      </div>
                    </div>
                    <div className="mb-20">
                      <label
                        htmlFor="email"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Email <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control radius-8"
                        id="email"
                        name="email" // Add the name attribute
                        value={formState.email}
                        onChange={handleInputChange} // Pass the event object directly
                        onBlur={() => setIsEmailTouched(true)} // Mark field as touched
                        placeholder="Enter email address"
                        required
                      />
                      {isEmailTouched && (
                        <>
                          {!formState.email && (
                            <small className="text-danger-600">
                              Email is required
                            </small>
                          )}
                          {formState.email &&
                            !emailRegex.test(formState.email) && (
                              <small className="text-danger-600">
                                Invalid email address
                              </small>
                            )}
                        </>
                      )}
                    </div>

                    <div className="mb-20">
                      <label
                        htmlFor="phone"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Contact
                        <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="phone"
                        name="phone"
                        value={formState.phone}
                        onChange={(e) => {
                          const regex = /^[0-9]*$/; // Allow numbers only
                          const value = e.target.value;

                          if (
                            (regex.test(value) || value === "") &&
                            value.length <= 15 // Enforce max length
                          ) {
                            handleInputChange(e); // Update state only if valid
                          }
                        }}
                        onBlur={() => {
                          setIsMobileTouched(true); // Mark field as touched when focus is lost
                          if (
                            formState.phone.length < 8 ||
                            formState.phone.length > 15
                          ) {
                            setError(
                              "Contact number must be between 8 and 15 digits."
                            );
                          } else {
                            setError(""); // Clear error if valid
                          }
                        }}
                        placeholder="Enter contact number"
                        maxLength={15} // Ensure no more than 15 characters
                        required
                      />
                      {/* {isMobileTouched && !formState.phone && (
                        <small className="text-danger-600">
                          Contact number is required
                        </small>
                      )} */}
                      {isMobileTouched && (
                          <>
                            {formState.phone &&
                              (formState.phone.length < 8 ||
                                formState.phone.length > 15) && (
                                <small className="text-danger-600">
                                  Contact number must be between 8 and 15
                                  digits.
                                </small>
                              )}
                          </>
                        )}
                    </div>

                    <div className="mb-20">
                      <label
                        htmlFor="address"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Address
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="address"
                        name="address"
                        value={formState.address}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || value.trim() !== "") {
                            handleInputChange(e); // Update state only if valid
                          }}
                        }
                        placeholder="Enter address (optional)"
                      />
                    </div>

                    <div className="mb-20">
                      <label
                        htmlFor="gender"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Gender
                        <span className="text-danger-600">*</span>
                      </label>
                      <select
                        id="gender"
                        name="gender"
                        value={formState.gender}
                        onChange={handleInputChange}
                        className="form-control radius-8"
                        required
                      >
                        <option value="" disabled>
                          Select Gender
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>

                    {/* Department */}
                    <div className="mb-20">
                      <label
                        htmlFor="department"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Department
                        <span className="text-danger-600">*</span>
                      </label>
                      <div className="custom-select">
                        <select
                          value={selectedDepartment || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setSelectedDepartment(selectedValue || "");
                          }}
                          className="form-control radius-8"
                          id="department"
                          required
                        >
                          <option value="" disabled>
                            Select Department
                          </option>
                          {departments.map((department) => (
                            <option key={department._id} value={department._id}>
                              {department.department_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                    >
                      {loading && (
         <div className="loader-container" style={styles.loaderContainer}>
                                              <CircularProgress />
                                            </div>
                                          )}
                                            Save
                    </button>
                  </div>
                </form>
              </div>
              <div
                className="tab-pane fade"
                id="pills-notification"
                role="tabpanel"
                aria-labelledby="pills-notification-tab"
                tabIndex={0}
              >
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="companzNew"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Company News
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="companzNew"
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="pushNotifcation"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Push Notification
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="pushNotifcation"
                      defaultChecked=""
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="weeklyLetters"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Weekly News Letters
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="weeklyLetters"
                      defaultChecked=""
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="meetUp"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Meetups Near you
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="meetUp"
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="orderNotification"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Orders Notifications
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="orderNotification"
                      defaultChecked=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddTutor;
